// src/pages/Enseignants/PassagesGrades/components/GradeStatsCards.jsx

import React from "react";
import {
  FaCheckCircle,
  FaClock,
  FaMedal,
  FaTimesCircle,
} from "react-icons/fa";

const ITEMS = [
  {
    key: "notGraded",
    label: "À noter",
    icon: FaClock,
    className:
      "bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-300",
  },
  {
    key: "graded",
    label: "Notés",
    icon: FaCheckCircle,
    className:
      "bg-blue-50 text-blue-700 dark:bg-blue-500/10 dark:text-blue-300",
  },
  {
    key: "obtained",
    label: "Obtenus",
    icon: FaMedal,
    className:
      "bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300",
  },
  {
    key: "failed",
    label: "Non obtenus",
    icon: FaTimesCircle,
    className:
      "bg-rose-50 text-rose-700 dark:bg-rose-500/10 dark:text-rose-300",
  },
];

const GradeStatsCards = ({ stats }) => {
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      {ITEMS.map((item) => {
        const Icon = item.icon;

        return (
          <div
            key={item.key}
            className="rounded-[24px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900"
          >
            <div
              className={`mb-3 flex h-10 w-10 items-center justify-center rounded-2xl ${item.className}`}
            >
              <Icon />
            </div>

            <p className="text-2xl font-bold text-slate-900 dark:text-white">
              {stats?.[item.key] || 0}
            </p>

            <p className="mt-1 text-sm font-medium text-slate-500 dark:text-slate-400">
              {item.label}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default GradeStatsCards;